import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const AlertFill = memo((props: IconProps) => {
    const { color = "#FFF", ...rest } = props
    return (
        <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                d="M13.4038 3.29715L23.3267 20.4847C23.4181 20.643 23.4662 20.8226 23.4662 21.0055C23.4662 21.1883 23.4181 21.368 23.3267 21.5263C23.2353 21.6847 23.1038 21.8162 22.9454 21.9076C22.7871 21.999 22.6074 22.0472 22.4246 22.0472H2.57875C2.3959 22.0472 2.21628 21.999 2.05793 21.9076C1.89958 21.8162 1.76808 21.6847 1.67666 21.5263C1.58524 21.368 1.53711 21.1883 1.53711 21.0055C1.53711 20.8226 1.58524 20.643 1.67667 20.4847L11.5996 3.29715C11.691 3.13881 11.8225 3.00733 11.9809 2.91591C12.1392 2.82449 12.3188 2.77637 12.5017 2.77637C12.6845 2.77637 12.8641 2.82449 13.0225 2.91591C13.1808 3.00733 13.3123 3.13881 13.4038 3.29715V3.29715ZM11.46 16.8388V18.9222H13.5433V16.8388H11.46ZM11.46 9.54716V14.7555H13.5433V9.54716H11.46Z"
                fill={color}
            />
        </svg>
    )
})
export default AlertFill
